// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HKrG","label":"styles_label__yDbfW"};